<template>
  <div @click="selected" class="multimedia__content-grid-item" role="button">
    <map-static-location
      :lat="lat"
      :lng="lng"
      :classes="'multimedia__content-grid-image'"
    />
    <div class="multimedia__content-grid-footer">
      <div class="multimedia__content-grid-footer-text">{{ name }}</div>
    </div>
  </div>
</template>

<script>
import MapStaticLocation from '@/components/shared/MapStaticLocation.vue';

export default {
  components: {
    MapStaticLocation,
  },
  props: {
    location: {
      required: true,
      type: Object,
    },
  },
  computed: {
    locationData() {
      return this.location.location;
    },
    lat() {
      return this.locationData.lat;
    },
    lng() {
      return this.locationData.lng;
    },
    name() {
      return this.locationData.name;
    },
  },
  methods: {
    selected() {
      this.$emit('selected', this.location);
    },
  },
};
</script>
